module.exports = __webpack_public_path__ + "img/17.d7808df0.png";